import { concatUrl } from './base'
import { appRequest } from './request'

const noticeUrl = concatUrl('/notice/findNoticeWhenLogin')
/**
 * 查询公告
 */
export async function myNoticeInfo () {
  const data = await appRequest(noticeUrl, {
    method: 'GET'
  })
  return data
}
